import rest from "@/rest-client";

/** TKP-122 — periyodik görev tanımları (organizasyon bazında). */
export const periodicTask = {
  namespaced: true,
  state: { definitions: [], periods: [], isLoading: false, isUpdating: false },
  getters: {
    definitions: (state) => state.definitions,
    periods: (state) => state.periods,
    isLoading: (state) => state.isLoading,
    isUpdating: (state) => state.isUpdating,
  },
  mutations: {
    list: (state, { definitions, periods }) => {
      state.definitions = definitions || [];
      state.periods = periods || [];
    },
    isLoading: (state, value) => (state.isLoading = value),
    isUpdating: (state, value) => (state.isUpdating = value),
  },
  actions: {
    async fetch({ commit }) {
      commit("isLoading", true);
      try {
        const response = await rest.get("/periodic-task");
        commit("list", response.data || {});
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
    /** Görev formundan tanım açar; metinler görev store'unun yerelleştirme kuralıyla hazırlanır (name/description → {dil}). */
    async create({ commit, dispatch }, form) {
      commit("isUpdating", true);
      try {
        // `editedEntity` boş nesne olmalı: hazırlayıcı yerelleştirmede `editedEntity[field]` okuyor (undefined → TypeError, sessiz kayıp)
        const item = await dispatch("task/preparePayload", { editedEntity: {}, form: { ...form } }, { root: true });
        return await rest.post("/periodic-task", { item });
      } finally {
        commit("isUpdating", false);
      }
    },
    async setActive({ commit, dispatch }, { _id, active }) {
      commit("isUpdating", true);
      try { const r = await rest.put(`/periodic-task/${_id}/active`, { active }); await dispatch("fetch"); return r; } finally { commit("isUpdating", false); }
    },
    async runNow({ commit, dispatch }, _id) {
      commit("isUpdating", true);
      try { const r = await rest.post(`/periodic-task/${_id}/run`); await dispatch("fetch"); return r; } finally { commit("isUpdating", false); }
    },
    async remove({ commit, dispatch }, _id) {
      commit("isUpdating", true);
      try { const r = await rest.delete(`/periodic-task/${_id}`); await dispatch("fetch"); return r; } finally { commit("isUpdating", false); }
    },
  },
};
